const initialState = {
    loading: false,
    pageloading: false,
    error: null,
    message: null,
    all_reports: [],
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    pageSize: 10,
    therapists: [],
  };
  
  export default function reportReducer(state = initialState, action) {
    switch (action.type) {
        case 'ALL_REPORTS':
        return { 
            ...state, 
            all_reports: action.payload.content || action.payload, 
            totalElements: action.payload.totalElements || 0,
            totalPages: action.payload.totalPages || 0,
            currentPage: action.payload.number || 0,
            pageSize: action.payload.size || 10,
            error: null,
            message: null 
        };
        case 'THERAPISTS_LIST':
        return {
            ...state,
            therapists: action.payload || [],
            error: null,
            message: null
        };
        default:
        return state;
    }
  }
  